<mat-accordion>
    <mat-expansion-panel class="icon" [expanded]="item.id == 0">
      <mat-expansion-panel-header>
        <mat-panel-title>
            {{ item.title }}
        </mat-panel-title>                        
        </mat-expansion-panel-header>
            @if (item.id == 0) {
                <mnf-pi-v2-opp-investment [detailsData]="infoProject?.newProject?.sectionOpInvest?.opportunityData" [infoProject]="infoProject"></mnf-pi-v2-opp-investment>
            } @else if (item.id == 1) {
                <mnf-pi-v2-opp-scheme [schemaFinancial]="infoProject?.newProject?.sectionOpInvest?.schemaOperation"  [schemaDescription]="infoProject?.newProject?.sectionOpInvest?.schemaDescription"></mnf-pi-v2-opp-scheme>
            } @else if (item.id == 2) {
                <mnf-pi-v2-opp-performance [infoProject]="infoProject"></mnf-pi-v2-opp-performance>
            } @else if (item.id == 3) {
                <mnf-pi-v2-opp-resumen-financial></mnf-pi-v2-opp-resumen-financial>
            } @else if (item.id == 4) {
                <mnf-pi-v2-opp-simulator [infoProject]="infoProject" [totalPerformance]="infoProject?.totalPerformance"></mnf-pi-v2-opp-simulator>
            } @else if (item.id == 5) {
                <mnf-pi-v2-opp-documents [campaignDocuments]="infoProject?.newProject?.sectionOpInvest?.documentsStep"></mnf-pi-v2-opp-documents>
            }
            @else if (item.id == 6) {
                <mnf-pi-v2-opp-updates [updates]="infoProject?.newProject?.sectionOpInvest?.updates"></mnf-pi-v2-opp-updates>
            }    
        </mat-expansion-panel>
</mat-accordion>